<div class="page-layout carded left-sidenav toolbar-fixed-layout">
  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="grid-toolbar-buttons-group-container w-p-100 flex flex-col justify-center items-start">
      <particle-breadcrumbs [breadcrumbs]="breadcrumbs"></particle-breadcrumbs>
    </div>
  </div>
  <!--<div class="toolbar second-level-toolbar" fxLayoutAlign="space-between center">
    <div fxLayout="column" fxLayoutAlign="center start" class="grid-toolbar-buttons-group-container">
      <label class="component-label"> Actions</label>
      <div class="grid-toolbar-buttons-group" fxLayout="row" fxLayoutAlign="start center">

        <div class="button-container" fxLayout="row" fxLayoutAlign="start center">
          <button mat-button class="orbitax-flat-button" (click)="startDataSurvey()"
                  particleAnalytics
                  analyticsCategory="pre-arrangements-content"
                  analyticsAction="start-data-survey"
          >Start Data Survey
          </button>

          <div class="toolbar-separator"></div>
        </div>

      </div>
    </div>
  </div>-->

  <mat-sidenav-container>

    <!-- CENTER -->
    <div class="center">
      <!-- CONTENT CARD -->
      <div particleHelpNotes helpNoteId="dac6-overview-case" class="content-card mat-white-bg">
        <!-- CONTENT TOOLBAR -->
        <div class="content  pos-relative m-30 flex flex-col full-grow-no-shrink-no-basis">
          <div class="keno-grid-container">
            <particle-virtual-grid [sourceKey]="sourceType"
                                   [sortFieldKey]="sortFieldKey"
                                   [sortDirection]="sortDirection"
                                   [invalidateSubject]="invalidateSubject"
                                   (valueChanged)="onGridCellValueChange($event)"
            >
            </particle-virtual-grid>
          </div>
        </div>
      </div>
      <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->

  </mat-sidenav-container>

</div>
